import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const LanguageContext = createContext();

// Helper to load labels dynamically
const loadLabels = (lang) => {
  if (lang === 'fr') {
    return require('../labels/labels.french.json');
  } else {
    return require('../labels/labels.json');
  }
};

export const LanguageProvider = ({ children }) => {
  // Default to localStorage or EN - using localStorage to persist across sessions
  const initialLang = localStorage.getItem('lng') || 'EN';
  const [language, setLanguage] = useState(initialLang);
  const [labels, setLabels] = useState(loadLabels(initialLang));

  useEffect(() => {
    setLabels(loadLabels(language));
    localStorage.setItem('lng', language);
    // Also set in sessionStorage for backward compatibility with existing code
    sessionStorage.setItem('lng', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, labels }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

// Export the context itself for useContext
export { LanguageContext };
